const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export const config = {
    baseApiUrl: BASE_API_URL,
};
